import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { triggerToastOff } from '../redux/actions';
import {
    getToastMessage,
    getToastType,
    getToastAnchorOrigin,
    getToastAutoHideDuration,
    getShowToast,
} from '../redux/selector';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ToastComponent({
    show,
    message,
    type,
    autoHideDuration,
    anchorOrigin,
    triggerToastOff,
}) {
    return (
        <Snackbar
            anchorOrigin={anchorOrigin}
            autoHideDuration={autoHideDuration}
            open={show}
            onClose={() => triggerToastOff()}
        >
            <Alert onClose={() => triggerToastOff()} severity={type}>
                {message}
            </Alert>
        </Snackbar>
    );
}

ToastComponent.propTypes = {
    message: PropTypes.string,
    type: PropTypes.string,
    autoHideDuration: PropTypes.number,
    anchorOrigin: PropTypes.object,
    show: PropTypes.bool,
    triggerToastOff: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        message: getToastMessage(state),
        type: getToastType(state),
        autoHideDuration: getToastAutoHideDuration(state),
        anchorOrigin: getToastAnchorOrigin(state),
        show: getShowToast(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        triggerToastOff: () => {
            dispatch(triggerToastOff());
        },
    };
};

const ConnectedToastComponent = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ToastComponent);

export default ConnectedToastComponent;
